/**
 * 　(c) 2018 TERAOKA SEIKO CO., LTD. / 株式会社 寺岡精工
 * 　CONFIDENTIAL / 社外秘
 * 　無断開示・無断複製禁止
 */
<template>
	<div>
		<table class="detailed-list header-user-setting">
			<!-- ユーザーID -->
			<c-edittext
				ref="v_user_id"
				:r_messages="r_messages"
				:r_settings="user_id_setting"
				r_validattype="half-width"
				:r_title="r_messages.user_id"
				:r_is_require="true"
				:r_max_length="r_settings.user_id_max"
				v-model="m_info.user_id"
				@keyup="onKeyup">
			</c-edittext>
			<!-- パスワード -->
			<tr class="tr-td-control">
				<td class="td-dataname">{{r_messages.passward}}</td>
				<td class="td-data">
					<!--変更するボタン-->
					<button
						class="update-btn"
						v-on:click="onBtnPassword">
						{{r_messages.password_update}}
					</button>
				</td>
			</tr>
			<!-- ユーザー名 -->
			<c-edittext
				ref="v_disp_text"
				:r_messages="r_messages"
				:r_settings="user_name_setting"
				:r_title="r_messages.user_name"
				:r_is_require="true"
				:r_max_length="r_settings.user_name_max"
				v-model="m_info.user_name"
				@keyup="onKeyup">
			</c-edittext>
			<!-- メールアドレス -->
			<c-edittext
				ref="v_mail_address"
				:r_messages="r_messages"
				:r_settings="r_settings"
				:r_title="r_messages.mail_address"
				:r_is_require="false"
				r_class="address"
				:r_max_length="USER_MAIL_ADDRESS_MAX"
				v-model="m_info.mail_address"
				@keyup="onKeyup">
			</c-edittext>
			<!-- weekカレンダー -->
			<c-editselectpulldown
				ref="v_week_calender"
				:r_messages="r_messages"
				:r_settings="r_settings"
				:r_is_require="false"
				:r_list="list_calender"
				:r_title="r_messages.week_calendar_cl"
				:r_func_cl="r_settings.week_calendar_cl"
				v-model="m_info.week_calendar_cl"
				@keyup="onKeyup">
			</c-editselectpulldown>
			<!-- 商品マスター詳細画面 -->
			<c-editselectpulldown
				ref="v_plu_display_type"
				:r_messages="r_messages"
				:r_settings="r_settings"
				:r_is_require="false"
				:r_list="list_plu_display_type"
				:r_title="r_messages.plu_display_type"
				:r_func_cl="r_settings.plu_display_type"
				v-model="m_info.plu_display_type"
				@keyup="onKeyup">
			</c-editselectpulldown>
		</table>
		<!-- パスワード設定画面 -->
		<div v-if="m_bConfirmPasswordDisp" class="user-confirm-password">
			<c-viewdialog
				r_dragid="drag-select"
				:r_title="r_messages.title_password_change"
				@event_cancel="OnPasswordCancel">
				<div slot="content">
					<c-user-password
						ref="v_user-password"
						:r_messages="r_messages"
						:r_settings="r_settings"
						:r_pass_title="r_messages.passward"
						:r_pass_confirm_title="r_messages.password_confirm"
						:r_max_length="r_settings.user_select.password_length"
						@event_confirm="onPasswordConfirm">
					</c-user-password>
				</div>
			</c-viewdialog>
		</div>
	</div>
</template>
<script>
	/**
	 * ユーザーの管理画面 - ユーザー情報の設定コンポーネント（ヘッダー呼び出し）
	 * @vuedoc
	 * @exports js/parts/user/viewHeaderParam
	 */
	export default {
		mixins: [
			require('js/common/viewParamBase.mixin.vue'),
		],
		data: function(){
			return {
				m_dispMessage: "",				// エラー時のメッセージ表示
				m_bConfirmPasswordDisp: false,	// パスワード設定画面の表示
			};
		},
		created: function(){
			this.m_strCode = this.r_info.company_code;
		},
		computed: {
			// ユーザーIDの設定情報変更
			user_id_setting: function(){
				// ユーザーIDは変更不可
				let obj = $.extend(true,{},this.r_settings);
				obj["edit_right"] = false;
				return obj;
			},
			// ユーザー名の設定情報変更
			user_name_setting: function(){
				// ユーザー名は変更不可
				return this.user_id_setting;
			},
			// weekカレンダーのリスト設定
			list_calender: function(){
				let msg = this.r_messages;
				return [
					{"value":0,"label":msg["week_calender_false"]},
					{"value":1,"label":msg["week_calender_true"]},
				];
			},
			// 商品マスター詳細画面 リスト設定
			list_plu_display_type: function(){
				let plu_display_type = [];
				let list = $.extend(true,{},
					this.r_settings.user_select.system_data[this.r_settings.user_select.plu_display_type_cl]
				);
				for (let key in list) {
					let tmp = list[key];
					tmp['value'] = tmp['system_code'];
					tmp['label'] = tmp['display_name'];
					plu_display_type.push(tmp);
				}
				return plu_display_type;
			},
		},
		methods: {
			/**
			 * r_infoの切り替え時
			 *
			 * @function onUpdateSrcData
			 */
			onUpdateSrcData: function(){
			},
			/**
			 * データ変更フラグの更新
			 *
			 * @function updateChangeDataFlag
			 */
			updateChangeDataFlag: function(){
				// ユーザーIDの変更フラグの更新
				if(this.$refs.v_user_id){
					this.$refs.v_user_id.setUpdate(this.checkChangeData(this.m_info.user_id ,this.r_info.user_id));
				}
				// ユーザー名の変更フラグの更新
				if(this.$refs.v_disp_text){
					this.$refs.v_disp_text.setUpdate(this.m_info.user_name != this.r_info.user_name);
				}
				// メールアドレスの変更フラグの更新
				if(this.$refs.v_mail_address){
					this.$refs.v_mail_address.setUpdate(this.m_info.mail_address!=this.r_info.mail_address);
				}
				// weekカレンダーの変更フラグの更新
				if(this.$refs.v_week_calender){
					this.$refs.v_week_calender.setUpdate(this.m_info.week_calendar_cl!=this.r_info.week_calendar_cl);
				}
				// 商品マスター詳細画面の変更フラグの更新
				if(this.$refs.v_plu_display_type){
					this.$refs.v_plu_display_type.setUpdate(this.m_info.plu_display_type!=this.r_info.plu_display_type);
				}
			},
			/**
			 * 更新確認
			 *
			 * @param {object} val 変更後データ
			 * @param {object} oldval 変更前データ
			 * @returns 更新されているかの有無
			 */
			checkChangeData: function(val, oldVal){
				if (this.r_is_new) {
					return true;
				}
				return val!=oldVal?true:false;
			},

			/**
			 * パスワードが変更されたか
			 *
			 * @returns 更新されているかの有無
			 */
			checkPasswordUpdate: function(){
				// パスワードが一度でも更新されていれば、passwordには必ず値が入る。
				return this.m_info.password != '' ?true:false;
			},
			/**
			 * 変更フラグcheck <br>
			 * ******* 内部処理 *******<br>
			 * 変更フラグを取得する。 <br>
			 *
			 * @function checkUpdate
			 *
			 * @returns 変更有無
			 */
			checkUpdate: function(){
				if ( this.$refs.v_user_id.checkUpdate() ||
					this.$refs.v_disp_text.checkUpdate() ||
					this.checkPasswordUpdate() ||
					this.$refs.v_mail_address.checkUpdate() ||
					this.$refs.v_week_calender.checkUpdate() ||
					this.$refs.v_plu_display_type.checkUpdate()
				) {
					return true;
				}
				return false;
			},
			/**
			 * バリデーション
			 *
			 * @function validate
			 *
			 * @returns バリデーション結果
			 */
			validate: function(){
				var is = true;
				if(this.$refs.v_mail_address){
					is = this.$refs.v_mail_address.validate()?is:false;
				}
				return is;
			},
			/**
			 * メッセージのクリア
			 *
			 * @function clearMessage
			 */
			clearMessage: function(){
				if(this.$refs.v_user_id){
					this.$refs.v_user_id.clearMessage();
				}
				if(this.$refs.v_disp_text){
					this.$refs.v_disp_text.clearMessage();
				}
				if(this.$refs.v_mail_address){
					this.$refs.v_mail_address.clearMessage();
				}
			},
			/**
			 * パスワード画面確認ボタン押下
			 */
			onPasswordConfirm: function(value){
				this.m_info.password = value;
				this.m_bConfirmPasswordDisp = false;
				return;
			},
			/**
			 * 更新データの取得
			 *
			 * @function getData
			 */
			getData: function(){
				return this.m_info;
			},
			/**
			 * 変更するボタン押下
			 */
			onBtnPassword: function(){
				this.m_bConfirmPasswordDisp = true;
			},
			/**
			 * パスワード確認画面閉じる
			 */
			OnPasswordCancel: function(){
				this.m_bConfirmPasswordDisp = false;
			},
		},
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts/user/header/viewHeaderParam.vue